import { render } from "./Kuhul3DComponent.vue?vue&type=template&id=79c92ffc"
import script from "./Kuhul3DComponent.vue?vue&type=script&lang=js"
export * from "./Kuhul3DComponent.vue?vue&type=script&lang=js"

import "./Kuhul3DComponent.vue?vue&type=style&index=0&id=79c92ffc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__